import React, {useEffect, useState} from "react";
import { useCookies } from "react-cookie";
import * as echarts from "echarts";
import $ from "jquery";
import DownloadFileIcon from "../../../icons/DownloadFileIcon";
import StringTools from "../../../../class/tool/StringTools";

const ChartModule = props => {
    const { id, classname, title, stats, model, clickOn } = props;
    const [ chartDatas, setChartDatas ] = useState({});
    const [ tableDatas, setTableDatas ] = useState([]);
    const [ tableTotalDatas, setTableTotalDatas ] = useState({});
    const [ chart, setChart ] = useState(null);
    const [ chartPref, setChartPref ] = useState(null);
    const [ cookies, setCookies ] = useCookies();
    let LOG = false;

    const checkCookies = () => {
        if (cookies[id + "Pref"] === undefined || Object.keys(cookies[id + "Pref"]).length === 0) {
            switch (id) {
                case "subPeriods": setCookies(id + "Pref", {sorting: "inclTax", type: "bar"}); break;
                case "payments": setCookies(id + "Pref", {sorting: "amount", type: "pie"}); break;
                case "vats":
                case "categories":
                case "subCategories":
                case "pricelists":
                    setCookies(id + "Pref", {sorting: "inclTax", type: "pie"}); break;
                case "products":
                    setCookies(id + "Pref", {sorting: "inclTax", type: "array"}); break;
                default: break;
            }
        }
        else {
            setChartPref(cookies[id + "Pref"]);

            const elmt = $("#" + id + "-" + cookies[id + "Pref"].sorting);

            if (elmt.length > 0) {
                $("#overlay-" + id).css({ width: elmt.innerWidth(), left: elmt.position().left });
            }
        }
    }
    const changeCookie = (name, value) => {
        setCookies(name, value);
    }
    const buildChartDatas = () => {
        if (stats === null) return;

        switch (id) {
            case "subPeriods": buildSubPeriodsDatas(); break;
            case "payments": buildPaymentsDatas(); break;
            case "vats": buildVatsDatas(); break;
            case "pricelists": buildPricelistsDatas(); break;
            case "categories": buildCategoriesDatas(); break;
            case "subCategories": buildSubCategoriesDatas(); break;
            default: break;
        }
    }
    const buildSubPeriodsDatas = () => {
        try {
            const { statsCA, statsSales } = stats;
            if (statsCA === null || statsSales === null) return;

            if (statsCA.date.subperiods !== undefined) {
                let xAxis = [];
                let datas = [];
                let sorting = "inclTax";

                if (chartPref !== null)
                    sorting = chartPref.sorting;

                for (let i in statsCA.date.subperiods) {
                    const subPeriodCA = statsCA.date.subperiods[i];
                    const subPeriodCAVersus = (statsCA.versus !== undefined && statsCA.versus.subperiods !== undefined && statsCA.versus.subperiods[i] !== undefined) ? statsCA.versus.subperiods[i] : null;
                    const subPeriodCADelta = (statsCA.delta !== undefined && statsCA.delta.subperiods !== undefined && statsCA.delta.subperiods[i] !== undefined) ? statsCA.delta.subperiods[i] : null;
                    const subPeriodSales = (statsSales.date !== undefined && statsSales.date.subperiods !== undefined && statsSales.date.subperiods[i] !== undefined) ? statsSales.date.subperiods[i] : null;
                    const subPeriodSalesVersus = (statsSales.versus !== undefined && statsSales.versus.subperiods !== undefined && statsSales.versus.subperiods[i] !== undefined) ? statsSales.versus.subperiods[i] : null;
                    const subPeriodSalesDelta = (statsSales.delta !== undefined && statsSales.delta.subperiods !== undefined && statsSales.delta.subperiods[i] !== undefined) ? statsSales.delta.subperiods[i] : null;

                    const avgQty = Math.round(parseInt(subPeriodCA.datas.quantity) / parseInt(subPeriodSales.datas.nb));
                    const avgQtyVersus = subPeriodSalesVersus !== null ? Math.round(parseInt(subPeriodCAVersus.datas.quantity) / parseInt(subPeriodSalesVersus.datas.nb)) : 0;
                    const avgQtyPercent = 100 - (avgQtyVersus * 100) / avgQty;
                    let value = 0;

                    switch (sorting) {
                        case "inclTax": value = parseFloat(subPeriodCA.datas.inclTax); break;
                        case "exclTax": value = parseFloat(subPeriodCA.datas.exclTax); break;
                        case "nb": value = parseInt(subPeriodSales.datas.nb); break;
                        case "averagePrice": value = parseFloat(subPeriodSales.datas.averagePrice); break;
                        case "averageQuantity": value = parseInt(avgQty); break;
                        default: break;
                    }

                    xAxis.push(subPeriodCA.def);
                    datas.push({
                        value: value,
                        inclTax: {
                            value: parseFloat(subPeriodCA.datas.inclTax),
                            variation: subPeriodCADelta !== null ? (subPeriodCADelta.datas.inclTaxValue > 0 ? "up" : "down") : "",
                            valueVariation: subPeriodCADelta !== null ? Math.abs(parseFloat(subPeriodCADelta.datas.inclTaxPercent)) : 0
                        },
                        exclTax: {
                            value: parseFloat(subPeriodCA.datas.exclTax),
                            variation: subPeriodCADelta !== null ? (subPeriodCADelta.datas.exclTaxValue > 0 ? "up" : "down") : "",
                            valueVariation: subPeriodCADelta !== null ? Math.abs(parseFloat(subPeriodCADelta.datas.exclTaxPercent)) : 0
                        },
                        nb: {
                            value: parseInt(subPeriodSales.datas.nb),
                            variation: subPeriodSalesDelta !== null ? (subPeriodSalesDelta.datas.nbValue > 0 ? "up" : "down") : "",
                            valueVariation: subPeriodSalesDelta !== null ? Math.abs(parseFloat(subPeriodSalesDelta.datas.nbPercent)) : 0
                        },
                        averagePrice: {
                            value: parseFloat(subPeriodSales.datas.averagePrice),
                            variation: subPeriodSalesDelta !== null ? (subPeriodSalesDelta.datas.averagePriceValue > 0 ? "up" : "down") : "",
                            valueVariation: subPeriodSalesDelta !== null ? Math.abs(parseFloat(subPeriodSalesDelta.datas.averagePricePercent)) : 0
                        },
                        averageQuantity: {
                            value: parseInt(avgQty),
                            variation: subPeriodSalesVersus !== null ? (avgQtyVersus > 0 ? "up" : "down") : "",
                            valueVariation: subPeriodSalesVersus !== null ? Math.abs(parseFloat(avgQtyPercent)) : 0
                        }
                    });
                }

                setChartDatas(prev => ({
                    ...prev,
                    xAxis: xAxis,
                    datas: datas
                }));
            }
        }
        catch (e) {
            if (LOG) console.log("SUB PERIODS DATAS", id, stats);
            console.error(e);
        }
    }
    const buildPaymentsDatas = () => {
        if (stats === null) return;

        try {
            let datas = [];
            let sorting = "amount";

            if (chartPref !== null)
                sorting = chartPref.sorting;

            for (let i in stats.date.period.datas) {
                const item = stats.date.period.datas[i];
                let delta = null;

                try {
                    delta = stats.delta.period.datas[i];
                }
                catch (e) {}

                datas.push({
                    value:  parseFloat(item.datas[sorting]),
                    name: item.metadatas.name.length > 3 ? StringTools.capitalizeFirstLetter(item.metadatas.name.toLowerCase()) : item.metadatas.name,
                    amount: {
                        value: parseFloat(item.datas.amount),
                        variation: delta !== null ? (delta.datas.amountValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.amountPercent)) : 0
                    },
                    quantity: {
                        value: parseFloat(item.datas.quantity),
                        variation: delta !== null ? (delta.datas.quantityValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.quantityPercent)) : 0
                    }
                })
            }

            setChartDatas(prev => ({
                ...prev,
                datas: datas
            }));
        }
        catch (e) {
            if (LOG) console.log("PAYMENTS DATAS", id, stats);
            console.error(e);
        }
    }
    const buildVatsDatas = () => {
        if (stats === null) return;

        try {
            let datas = [];
            let sorting = "amount";

            if (chartPref !== null)
                sorting = chartPref.sorting;

            for (let i in stats.date.period.datas) {
                const item = stats.date.period.datas[i];
                let delta = null;

                try {
                    delta = stats.delta.period.datas[i];
                }
                catch (e) {}

                datas.push({
                    value: parseFloat(item.datas[sorting]),
                    name: StringTools.capitalizeFirstLetter(item.metadatas.name.toLowerCase()),
                    amount: {
                        value: parseFloat(item.datas.amount),
                        variation: delta !== null ? (delta.datas.amountValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.amountPercent)) : 0
                    },
                    exclTax: {
                        value: parseFloat(item.datas.exclTax),
                        variation: delta !== null ? (delta.datas.exclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.exclTaxPercent)) : 0
                    },
                    inclTax: {
                        value: parseFloat(item.datas.inclTax),
                        variation: delta !== null ? (delta.datas.inclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.inclTaxPercent)) : 0
                    }
                })
            }

            setChartDatas(prev => ({
                ...prev,
                datas: datas
            }));
        }
        catch (e) {
            if (LOG) console.log("VATS DATAS", id, stats);
            console.error(e);
        }
    }
    const buildPricelistsDatas = () => {
        if (stats === null) return;

        try {
            let datas = [];
            let sorting = "amount";

            if (chartPref !== null)
                sorting = chartPref.sorting;

            for (let i in stats.date.period.datas) {
                const item = stats.date.period.datas[i];
                let delta = null;

                try {
                    delta = stats.delta.period.datas[i];
                }
                catch (e) {}

                datas.push({
                    value: parseFloat(item.datas[sorting]),
                    name: StringTools.capitalizeFirstLetter(item.metadatas.name.toLowerCase()),
                    exclTax: {
                        value: parseFloat(item.datas.exclTax),
                        variation: delta !== null ? (delta.datas.exclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.exclTaxPercent)) : 0
                    },
                    inclTax: {
                        value: parseFloat(item.datas.inclTax),
                        variation: delta !== null ? (delta.datas.inclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.inclTaxPercent)) : 0
                    }
                })
            }

            setChartDatas(prev => ({
                ...prev,
                datas: datas
            }));
        }
        catch (e) {
            if (LOG) console.log("PRICELISTS DATAS", id, stats);
            console.error(e);
        }
    }
    const buildCategoriesDatas = () => {
        if (stats === null) return;

        try {
            let datas = [];
            let sorting = "inclTax";

            if (chartPref !== null)
                sorting = chartPref.sorting;

            for (let i in stats.date.period.datas) {
                const item = stats.date.period.datas[i];
                let delta = null;

                try {
                    delta = stats.delta.period.datas[i];
                }
                catch (e) {}

                datas.push({
                    value: parseFloat(item.datas[sorting]),
                    name: StringTools.capitalizeFirstLetter(item.metadatas.name.toLowerCase()),
                    quantity: {
                        value: parseFloat(item.datas.quantity),
                        variation: delta !== null ? (delta.datas.quantityValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.quantityPercent)) : 0
                    },
                    exclTax: {
                        value: parseFloat(item.datas.exclTax),
                        variation: delta !== null ? (delta.datas.exclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.exclTaxPercent)) : 0
                    },
                    inclTax: {
                        value: parseFloat(item.datas.inclTax),
                        variation: delta !== null ? (delta.datas.inclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.inclTaxPercent)) : 0
                    }
                })
            }

            setChartDatas(prev => ({
                ...prev,
                datas: datas
            }));
        }
        catch (e) {
            if (LOG) console.log("CATEGORIES DATAS", id, stats);
            console.error(e);
        }
    }
    const buildSubCategoriesDatas = () => {
        if (stats === null) return;

        try {
            let datas = [];
            let sorting = "inclTax";

            if (chartPref !== null)
                sorting = chartPref.sorting;

            for (let i in stats.date.period.datas) {
                const item = stats.date.period.datas[i];
                let delta = null;

                try {
                    delta = stats.delta.period.datas[i];
                }
                catch (e) {}

                datas.push({
                    value: parseFloat(item.datas[sorting]),
                    name: StringTools.capitalizeFirstLetter(item.metadatas.name.toLowerCase()),
                    quantity: {
                        value: parseFloat(item.datas.quantity),
                        variation: delta !== null ? (delta.datas.quantityValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.quantityPercent)) : 0
                    },
                    exclTax: {
                        value: parseFloat(item.datas.exclTax),
                        variation: delta !== null ? (delta.datas.exclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.exclTaxPercent)) : 0
                    },
                    inclTax: {
                        value: parseFloat(item.datas.inclTax),
                        variation: delta !== null ? (delta.datas.inclTaxValue > 0 ? "up" : "down") : "",
                        valueVariation: delta !== null ? Math.abs(parseFloat(delta.datas.inclTaxPercent)) : 0
                    }
                })
            }

            setChartDatas(prev => ({
                ...prev,
                datas: datas
            }));
        }
        catch (e) {
            if (LOG) console.log("SUB CATEGORIES DATAS", id, stats);
            console.error(e);
        }
    }
    const buildTableDatas = () => {
        if (stats === null) return;

        let datas = {};

        try {
            switch (id) {
                case "subPeriods": datas = buildSubPeriodsTableDatas(); break;
                case "payments":
                case "vats":
                case "pricelists":
                case "categories":
                case "subCategories":
                case "products": datas = buildItemsTableDatas(); break;
                default: break;
            }
        }
        catch (e) {
            if (LOG) console.log("TABLE DATAS", id, stats);
            console.error(e);
        }

        setTableDatas(datas.datas);
        setTableTotalDatas(datas.total);
    }
    const buildSubPeriodsTableDatas = () => {
        let datas = {
            datas: [],
            total: {}
        };

        if (stats.statsCA !== null && stats.statsSales !== null && stats.statsCA.date.subperiods !== undefined) {
            for (let i in stats.statsCA.date.subperiods) {
                const subPeriodCA = stats.statsCA.date.subperiods[i];
                const subPeriodSales = (stats.statsSales.date !== undefined && stats.statsSales.date.subperiods !== undefined && stats.statsSales.date.subperiods[i] !== undefined) ? stats.statsSales.date.subperiods[i] : null;
                const avgQty = Math.round(parseInt(subPeriodCA.datas.quantity) / parseInt(subPeriodSales.datas.nb));

                datas.datas.push({
                    metadatas: {
                        name: subPeriodCA.def
                    },
                    datas: {
                        inclTax: parseFloat(subPeriodCA.datas.inclTax),
                        exclTax: parseFloat(subPeriodCA.datas.exclTax),
                        nb: parseInt(subPeriodSales.datas.nb),
                        averagePrice: parseFloat(subPeriodSales.datas.averagePrice),
                        averageQuantity: parseInt(avgQty)
                    }
                });
            }
        }

        return datas;
    }
    const buildItemsTableDatas = () => {
        let datas = {
            datas: [],
            total: {}
        };

        if (model.inTotal) {
            for (let i in model.table) {
                switch (model.table[i].inTotal) {
                    case "label":
                        datas.total[model.table[i].object] = "Total";
                        break;
                    case "value":
                        datas.total[model.table[i].object] = 0;
                        break;
                    default:
                        datas.total[model.table[i].object] = "";
                        break;
                }
            }
        }

        for (let i in stats.date.period.datas) {
            const entry = stats.date.period.datas[i];
            datas.datas.push(entry);

            if (model.inTotal) {
                for (let i in model.table) {
                    switch (model.table[i].inTotal) {
                        case "value":
                            datas.total[model.table[i].object] += entry[model.table[i].target][model.table[i].object];
                            break;
                        default: break;
                    }
                }
            }
        }

        if (cookies[id + "Pref"] !== undefined) {
            let elmtSorting = model.table.find(_ => _.object === cookies[id + "Pref"].sorting);

            if (elmtSorting !== undefined)
                datas.datas.sort((a, b) => b[elmtSorting.target][elmtSorting.object] - a[elmtSorting.target][elmtSorting.object]);
        }

        if (model.limit !== undefined)
            datas.datas = datas.datas.slice(0, model.limit);

        return datas;
    }
    const initCharts = () => {
        if (chart === null) {
            const chartContainer = document.querySelector('#' + id + 'Chart');
            setChart(echarts.init(chartContainer));
        }
    }
    const buildChart = ()=> {
		if (chart === null || chartDatas === null) return;

        switch (id) {
            case "subPeriods": buildSubPeriodsChart(); break;
            case "payments": buildPaymentsChart(); break;
            case "vats": buildVatsChart(); break;
            case "pricelists": buildPricelistsChart(); break;
            case "categories": buildCategoriesChart(); break;
            case "subCategories": buildSubCategoriesChart(); break;
            default: break;
        }
	}
    const buildSubPeriodsChart = ()=> {
        try {const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: params => {
                        try {
                            const { name, data } = params[0];

                            return '<div class="tooltip">' +
                                '<p class="title">' + echarts.format.encodeHTML(name) + '</p>' +
                                '<div class="key">' +
                                    '<p class="title">Chiffre d\'affaires</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.inclTax.value, 2, ",", " ")) + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Ventes</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.nb.value, 0, ",", " ")) + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Panier moyen</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.averagePrice.value, 2, ",", " ")) + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Articles moyen</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.averageQuantity.value, 0, ",", " ")) + '</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
                            /*
                            return '<div class="tooltip">' +
                                '<p class="title">' + echarts.format.encodeHTML(name) + '</p>' +
                                '<div class="key">' +
                                    '<p class="title">Chiffre d\'affaires</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.inclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.inclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.inclTax.variation + '">' + (data.inclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.inclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Ventes</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.nb.value, 0, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.nb.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.nb.variation + '">' + (data.nb.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.nb.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Panier moyen</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.averagePrice.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.averagePrice.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.averagePrice.variation + '">' + (data.averagePrice.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.averagePrice.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Articles moyen</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.averageQuantity.value, 0, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.averageQuantity.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.averageQuantity.variation + '">' + (data.averageQuantity.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.averageQuantity.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
                            */
                        }
                        catch (e) { console.error(e); }
                    }
                },
                grid: {
                    left: '4%',
                    right: '5%',
                    top: '15%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: chartDatas.xAxis
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: chartDatas.datas,
                        type: 'bar',
                        itemStyle: {
                            color: '#00406F',
                            borderRadius: [5, 5, 0, 0]
                        }
                    }
                ]
            };

            option && chart.setOption(option);
        }
        catch (e) {
            if (LOG) console.log("SUB PERIODS CHART");
            console.error(e);
        }
	}
    const buildPaymentsChart = ()=> {
        try {
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: params => {
                        try {
                            const { data } = params;
                            return '<div class="tooltip">' +
                                '<p class="title">' + echarts.format.encodeHTML(data.name) + '</p>' +
                                '<div class="key">' +
                                    '<p class="title">Montant</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.amount.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.amount.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.amount.variation + '">' + (data.amount.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.amount.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Quantité</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.quantity.value, 0, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.quantity.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.quantity.variation + '">' + (data.quantity.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.quantity.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
                        }
                        catch (e) { console.error(e); }
                    }
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    bottom: '5%',
                    left: '2%'
                },
                series: [
                    {
                        name: 'Règlements',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: chartDatas.datas
                    }
                ]
            };

            option && chart.setOption(option);
        }
        catch (e) {
            if (LOG) console.log("PAYMENTS CHART");
            console.error(e);
        }
	}
    const buildVatsChart = ()=> {
        try {
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: params => {
                        try {
                            const { data } = params;
                            return '<div class="tooltip">' +
                                '<p class="title">' + echarts.format.encodeHTML(data.name) + '</p>' +
                                '<div class="key">' +
                                    '<p class="title">Montant</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.amount.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.amount.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.amount.variation + '">' + (data.amount.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.amount.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">HT</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.exclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.exclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.exclTax.variation + '">' + (data.exclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.exclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">TTC</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.inclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.inclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.inclTax.variation + '">' + (data.inclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.inclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
                        }
                        catch (e) { console.error(e); }
                    }
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    bottom: '5%',
                    left: '2%'
                },
                series: [
                    {
                        name: 'TVA',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: chartDatas.datas
                    }
                ]
            };

            option && chart.setOption(option);
        }
        catch (e) {
            if (LOG) console.log("VATS CHART");
            console.error(e);
        }
	}
    const buildPricelistsChart = ()=> {
        try {
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: params => {
                        try {
                            const { data } = params;
                            return '<div class="tooltip">' +
                                '<p class="title">' + echarts.format.encodeHTML(data.name) + '</p>' +
                                '<div class="key">' +
                                    '<p class="title">HT</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.exclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.exclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.exclTax.variation + '">' + (data.exclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.exclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">TTC</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.inclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.inclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.inclTax.variation + '">' + (data.inclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.inclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
                        }
                        catch (e) { console.error(e); }
                    }
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    bottom: '5%',
                    left: '2%'
                },
                series: [
                    {
                        name: 'Tarifs',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: chartDatas.datas
                    }
                ]
            };

            option && chart.setOption(option);
        }
        catch (e) {
            if (LOG) console.log("PRICELISTS CHART");
            console.error(e);
        }
	}
    const buildCategoriesChart = ()=> {
        try {
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: params => {
                        try {
                            const { data } = params;
                            return '<div class="tooltip">' +
                                '<p class="title">' + echarts.format.encodeHTML(data.name) + '</p>' +
                                '<div class="key">' +
                                    '<p class="title">HT</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.exclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.exclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.exclTax.variation + '">' + (data.exclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.exclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">TTC</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.inclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.inclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.inclTax.variation + '">' + (data.inclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.inclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Quantité</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.quantity.value, 0, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.quantity.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.quantity.variation + '">' + (data.quantity.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.quantity.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
                        }
                        catch (e) { console.error(e); }
                    }
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    bottom: '5%',
                    left: '2%'
                },
                series: [
                    {
                        name: 'Catégories',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: chartDatas.datas
                    }
                ]
            };

            option && chart.setOption(option);
        }
        catch (e) {
            if (LOG) console.log("CATEGORIES CHART");
            console.error(e);
        }
	}
    const buildSubCategoriesChart = ()=> {
        try {
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: params => {
                        try {
                            const { data } = params;
                            return '<div class="tooltip">' +
                                '<p class="title">' + echarts.format.encodeHTML(data.name) + '</p>' +
                                '<div class="key">' +
                                    '<p class="title">HT</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.exclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.exclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.exclTax.variation + '">' + (data.exclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.exclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">TTC</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.inclTax.value, 2, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.inclTax.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.inclTax.variation + '">' + (data.inclTax.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.inclTax.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="key marginTop">' +
                                    '<p class="title">Quantité</p>' +
                                    '<div class="values marginBottom">' +
                                        '<p class="value">' + echarts.format.encodeHTML(StringTools.number_format(data.quantity.value, 0, ",", " ")) + '</p>' +
                                        '<div class="variation ' + data.quantity.variation + '"></div>' +
                                        '<p class="valueVariation ' + data.quantity.variation + '">' + (data.quantity.valueVariation !== 0 ? echarts.format.encodeHTML(StringTools.number_format(data.quantity.valueVariation, 1, ",", " ")) + " %" : "") + '</p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
                        }
                        catch (e) { console.error(e); }
                    }
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    bottom: '5%',
                    left: '2%'
                },
                series: [
                    {
                        name: 'Sous-catégories',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 12,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: chartDatas.datas
                    }
                ]
            };

            option && chart.setOption(option);
        }
        catch (e) {
            if (LOG) console.log("SUB CATEGORIES CHART");
            console.error(e);
        }
	}
    const buildTableValue = (data, row) => {
        switch (row.type) {
            case "text": return data[row.target][row.object].length > 3 ? StringTools.capitalizeFirstLetter(data[row.target][row.object].toLowerCase()) : data[row.target][row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "int": return StringTools.number_format(data[row.target][row.object], 0, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "decimal": return StringTools.number_format(data[row.target][row.object], 2, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            default: return data[row.target][row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
        }
    }
    const buildTotalValue = row => {
        switch (row.type) {
            case "text": return tableTotalDatas[row.object].length > 3 ? StringTools.capitalizeFirstLetter(tableTotalDatas[row.object].toLowerCase()) : tableTotalDatas[row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "int": return StringTools.number_format(tableTotalDatas[row.object], 0, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            case "decimal": return StringTools.number_format(tableTotalDatas[row.object], 2, ",", " ") + (row.suffix.length > 0 ? " " + row.suffix : "");
            default: return tableTotalDatas[row.object] + (row.suffix.length > 0 ? " " + row.suffix : "");
        }
    }
    const clickOnRow = row => {
        if (!model.selectable || clickOn === undefined)
            return;

        clickOn(row);
    }

    useEffect(() => {
        initCharts();
    }, []);
    useEffect(() => {
        checkCookies();
    }, [cookies]);
    useEffect(() => {
        buildChartDatas();
        buildTableDatas();

        if (chart !== null)
            chart.resize();
    }, [stats, chartPref]);
    useEffect(() => {
        if (chart !== null) {
            window.addEventListener("resize", () => {
                chart.resize();
            });
        }
        return () => window.removeEventListener('resize', () => {});
    }, [chart]);
    useEffect(() => {
        buildChart();
    }, [chart, chartDatas]);

    return(
        <div className={classname}>
            <header>
                <p className={"title"}>{ title }</p>
                <div className={"sorting"}>
                    <div id={"overlay-" + id} className={"bgOverlay"} />
                    {
                        (model.sorting !== undefined && model.sorting !== null)
                        && model.sorting.map((sorting, index) => (
                            <p key={index} id={id + "-" + sorting.value} className={"sort" + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === sorting.value ? " selected" : "")} onClick={() => { changeCookie(id + "Pref", { sorting: sorting.value, type: cookies[id + "Pref"].type }) }}>{ sorting.title }</p>
                        ))
                    }
                </div>
                <div className={"types"}>
                    {
                        (model.types !== undefined && model.types !== null)
                        && model.types.map((type, index) => (
                            <p key={index} id={id + "-" + type.value} className={"type" + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].type === type.value ? " selected" : "")} onClick={() => { changeCookie(id + "Pref", { sorting: cookies[id + "Pref"].sorting, type: type.value }) }}>{ type.icon }</p>
                        ))
                    }
                    {
                        model.downloadable
                        && <p className={"type"}><DownloadFileIcon /></p>
                    }
                </div>
            </header>
            <div id={id + "Chart"} className={"chart" + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].type === "array" ? " hidden" : "")} />
            {
                (tableDatas !== undefined && model.table !== undefined && model.types.find(_ => _.value === "array") !== undefined)
                && <div className={"containerSortingTable" + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].type !== "array" ? " hidden" : "")}>
                    <table className={"sortingTable"}>
                        <thead>
                            <tr>
                            {
                                model.table.map((row, index) => (
                                    <th key={index} className={row.classname + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === row.object ? " selected" : "")}>{ row.name }</th>
                                ))
                            }
                            </tr>
                        </thead>
                        <tbody>
                        {
                            tableDatas.map((data, index) => (
                                <tr key={index} className={(model.selectable ? "selectable" : "")} onClick={() => { clickOnRow(data) }}>
                                    {
                                        model.table.map((row, index) => (
                                            <td key={index} className={row.classname + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === row.object ? " selected" : "")}>{ buildTableValue(data, row) }</td>
                                        ))
                                    }
                                </tr>
                            ))
                        }
                        {
                            model.inTotal && Object.keys(tableTotalDatas).length > 0
                            && <tr className={"total"}>
                                {
                                    model.table.map((row, index) => (
                                        <td key={index} className={row.classname + " total" + (cookies[id + "Pref"] !== undefined && cookies[id + "Pref"].sorting === row.object ? " selected" : "")}>{ buildTotalValue(row) }</td>
                                    ))
                                }
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default ChartModule;
